import {
  ApolloClient,
  ApolloLink,
  ApolloProvider,
  HttpLink,
  InMemoryCache,
  split,
} from '@apollo/client'
import React, { useState, useEffect } from 'react'
import { getMainDefinition } from '@apollo/client/utilities'
import { Spin, Space } from 'antd'
// import { WebSocketLink } from '@apollo/client/link/ws'
// import 'subscriptions-transport-ws'
import { setContext } from '@apollo/client/link/context'
import { config } from './config/index'
import WebSocketLink from './websocketLink'
import { useMsal } from '@azure/msal-react'
import { useIsAuthenticated } from '@azure/msal-react'
import { InteractionRequiredAuthError } from '@azure/msal-browser'
import { setCookie } from './utils/cookieUtils'
import { COMMON_CONSTANTS } from './commonConstants'
import { RestLink } from 'apollo-link-rest'

const ApolloWrapper = (props: any) => {
  const { children } = props
  const [token, setToken] = useState('')
  const isAuthenticated = useIsAuthenticated()
  const { instance, accounts } = useMsal()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (isAuthenticated && accounts.length > 0) {
      const request = {
        scopes: config.scopes,
        account: accounts[0],
      }
      instance
        .acquireTokenSilent(request)
        .then((response) => {
          console.log('in success')
          setToken(response.accessToken)
          setCookie(COMMON_CONSTANTS.authTokenKey, response.accessToken)
          setLoading(false)
        })
        .catch((error) => {
          console.log('in error')
          // acquireTokenSilent can fail for a number of reasons, fallback to interaction
          if (error instanceof InteractionRequiredAuthError) {
            instance.acquireTokenPopup(request).then((response) => {
              setToken(response.accessToken)
              setLoading(false)
            })
          }
        })
    } else {
      setLoading(false)
    }
  }, [isAuthenticated, accounts, instance])

  const wsLink = new WebSocketLink({
    url: config.subscriptionApi,
    connectionParams: () => ({
      authorization: token,
    }),
  })

  const httpLink = new HttpLink({
    uri: config.graphql,
  })

  const restLink = new RestLink({
    uri: config.restEndpoint,
    endpoints: {
      rest: config.restEndpoint,
    },
  })

  const authLink = setContext((_, { headers, ...rest }) => {
    if (!token) return { headers, ...rest }
    return {
      ...rest,
      headers: {
        ...Headers,
        authorization: `${token}`,
      },
    }
  })

  const link = split(
    ({ query }) => {
      // split based on operation type
      const definition = getMainDefinition(query)
      return definition.kind === 'OperationDefinition' && definition.operation === 'subscription'
    },
    wsLink,
    ApolloLink.from([authLink, restLink, httpLink])
  )

  const client = new ApolloClient({
    link,
    cache: new InMemoryCache({
      addTypename: false,
    }),
    connectToDevTools: config.environment === 'LOCAL',
  })

  return (loading || token === '') && isAuthenticated ? (
    <Space direction="vertical" align="center" style={{ width: '100%', height: '100vh' }}>
      <Spin tip="Loading" size="large">
        <div className="loadingContent" />
      </Spin>
    </Space>
  ) : (
    <ApolloProvider client={client}>{children}</ApolloProvider>
  )
}

export default ApolloWrapper
